import { trpc } from '@/config/trpc'
import { useParams } from 'react-router'
import ScheduleAgentPage from '../schedule-agent'

export default function CampaignDetailPage() {
  const { id } = useParams()
  const { data: campaign, isLoading } = trpc.campaign.get.useQuery(
    { id: Number(id) },
    { enabled: !!id },
  )

  if (isLoading) return <div>Loading...</div>
  if (!campaign) return <div>Campaign not found</div>

  return <ScheduleAgentPage campaign={campaign} />
}
